import React, { Component } from 'react'
import styled from 'styled-components'
import easing from 'ui/styles/easing'

const Wrapper = styled.div`
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;

  svg path {
    transition: fill 0.3s ${easing.easeOutCubic};
  }
`

export default class PlayIcon extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="64"
          height="46"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            fillRule="evenodd"
          >
              <path
                className="hover-path"
                fill="#474747"
                d="M9.65815912 1.38368097S20.3021559.483001 31.4827497.483001c11.3622868 0 22.3710089.90067997 22.3710089.90067997 4.9311574 0 8.9284039 4.03234421 8.9284039 9.00679967 0 0 .4464202 6.02149596.4464202 12.85900786 0 6.6708862-.4464202 12.3600312-.4464202 12.3600312 0 4.9744555-3.9972465 9.0067997-8.9284039 9.0067997 0 0-10.264986.9006799-21.2464764.9006799-11.5484441 0-22.94912308-.9006799-22.94912308-.9006799-4.93115749 0-8.92840392-4.0323442-8.92840392-9.0067997 0 0-.4464202-5.2631234-.4464202-11.7025348 0-7.0437677.4464202-13.51650426.4464202-13.51650426 0-4.97445546 3.99724643-9.00679967 8.92840392-9.00679967"
              />
              <path
                fill="#FFF"
                d="M25.4614341 14.4435405v17.5632593l17.0851386-9.0067996z"
              />
              <path
                fill="#CCC"
                d="M42.302525 23.1286623l.1879365-.1567183-17.0289375-8.5285386 14.3339817 10.0070048z"
              />
          </g>
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Videos/PlayIcon.js